import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Music, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { API } from "./upload";

const fmtTime = (s) => `${Math.floor((s || 0) / 60)}:${String(Math.floor((s || 0) % 60)).padStart(2, "0")}`;

// User's uploaded music — persists across projects until manually deleted.
export const SavedMusic = ({ selectedFileId, onSelect, refreshKey = 0 }) => {
  const [tracks, setTracks] = useState([]);

  const load = useCallback(() => {
    axios.get(`${API}/funtime/my-music`).then((r) => setTracks(r.data.tracks || [])).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  const del = async (e, t) => {
    e.stopPropagation();
    try {
      await axios.delete(`${API}/funtime/file/${t.file_id}`);
      toast.success(`"${t.filename}" removed from your music`);
      load();
    } catch {
      toast.error("Could not delete track");
    }
  };

  if (!tracks.length) return null;
  return (
    <div className="space-y-1" data-testid="saved-music">
      <p className="font-mono text-[10px] uppercase text-muted-foreground">My saved music — stays here for future projects</p>
      <ul className="space-y-1 max-h-32 overflow-y-auto pr-1">
        {tracks.map((t, i) => (
          <li
            key={t.file_id}
            onClick={() => onSelect(t)}
            className={`flex items-center gap-2 rounded-md border px-2 py-1.5 cursor-pointer font-mono text-[11px] transition-colors ${selectedFileId === t.file_id ? "border-primary bg-primary/15" : "border-border/50 hover:border-primary/50"}`}
            data-testid={`saved-music-${i}`}
          >
            <Music className="w-3.5 h-3.5 text-primary flex-shrink-0" />
            <span className="truncate flex-1">{t.filename}</span>
            <span className="text-[10px] text-muted-foreground">{fmtTime(t.duration)}</span>
            <button onClick={(e) => del(e, t)} className="p-0.5 text-rose-400 hover:text-rose-300" title="Delete track" data-testid={`saved-music-delete-${i}`}>
              <Trash2 className="w-3 h-3" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
